import axios from 'axios'
import * as routes from './routes'

class Globals {
  constructor() {
    this.genres = null
    this.stripePrices = null
  }

  load(callback) {
    const genreRequest = axios.get(routes.genreUrl)
    const stripePricesRequest = axios.get(routes.stripePricesUrl)
    axios.all(
      [genreRequest, stripePricesRequest]
    ).then(axios.spread((genreResponse, stripeResponse) => {
      this.genres = genreResponse.data.data
      this.stripePrices = stripeResponse.data
      callback()
    })).catch((error) => {
      callback(error)
    })
  }
}

export default new Globals()
